const MOBILE_MEDIA = '(max-width: 767px)';

const parallaxElements = document.querySelectorAll('[data-parallax-circle]');

let currentScrollY = window.scrollY;

const isBlockInView = (element) => {
  const fromTop = element.getBoundingClientRect().top;
  const height = element.getBoundingClientRect().height;
  return (fromTop >= -height) && (fromTop <= document.documentElement.clientHeight);
};

const setElementsPosition = (position) => {
  parallaxElements.forEach(function (element) {
    if (element.hasAttribute('data-speed')) {
      element.style.transform = `translate3d(0, ${position}px, 0)`;
    }
  });
};

const translateItems = (scrollY) => {
  const diff = scrollY - currentScrollY;

  parallaxElements.forEach((element) => {
    if (!element.hasAttribute('data-speed')) {
      return;
    }

    if (isBlockInView(element)) {
      const currentValue = parseInt(
          getComputedStyle(element).transform.
              split('matrix(')[1].
              split(')')[0].
              split(', ')[5],
          10);
      const speed = element.dataset.speed / 100;
      const elementScrollSpeed = diff * speed;

      if (diff !== elementScrollSpeed) {
        const elementScrollDiff = diff - elementScrollSpeed;
        const newValue = currentValue + elementScrollDiff;
        element.style.transform = `translate3d(0, ${newValue}px, 0)`;
      }
    }
  });

  currentScrollY = scrollY;
};

const onWindowScroll = () => {
  translateItems(window.scrollY);
};

let wasScrollListenerAdded = false;

const checkMedia = () => {
  setElementsPosition(0);
  currentScrollY = window.scrollY;

  if (!window.matchMedia(MOBILE_MEDIA).matches) {
    if (!wasScrollListenerAdded) {
      window.addEventListener('scroll', onWindowScroll);
      wasScrollListenerAdded = true;
    }
  } else {
    if (wasScrollListenerAdded) {
      window.removeEventListener('scroll', onWindowScroll);
      wasScrollListenerAdded = false;
    }
  }
};

const initCircleParallax = () => {
  if (parallaxElements.length <= 0) {
    return;
  }

  checkMedia();

  window.addEventListener('resize', function () {
    checkMedia();
  });
};

export {initCircleParallax};
